<template>
  <DatatableV3
    id="communications-change-history-table"
    :key="layoutType"
    ref="table"
    :config="config"
    :source="source"
  />
</template>

<script setup lang="ts">
import { ref } from "vue";

import DatatableV3 from "@/components/DatatableV3.vue";
import { useBreakpoints } from "@/composables/useBreakpoints";

defineProps({
  source: {
    type: String,
    required: true
  }
});

// Responsive cannot be switched on a live table, so crossing md remounts it.
const { type: layoutType } = useBreakpoints();

const config = {
  lengthChange: true,
  pageLength: 10,
  order: [[0, "desc"]],
  responsive: true,
  columns: [
    {
      data: "datetime",
      title: "Date & Time",
      orderable: true,
      responsivePriority: 1
    },
    {
      data: "updates",
      title: "Changes",
      orderable: false,
      className: "wrap-when-responsive",
      responsivePriority: 2
    },
    {
      data: "admin",
      title: "Changed By",
      orderable: true,
      responsivePriority: 3
    },
    {
      data: "reason",
      title: "Reason for change",
      className: "reason-column",
      responsivePriority: 4
    }
  ]
};

const table = ref(null);

function refresh() {
  //@ts-expect-error no component type
  table.value?.refreshData();
}

defineExpose({ refresh });
</script>

<style lang="scss">
table#communications-change-history-table {
  .reason-column {
    max-width: 500px;
    white-space: normal;
  }
}
</style>
